<template>
  <div>
    <HeroSection />
    <FlyWheel />
    <Brands />
    <Creators />
    <CaseStudies />
    <MeetTobias />
    <GetInTouch :homepage="true" />
  </div>
</template>

<script setup lang="ts">
import HeroSection from '../components/HeroSection.vue';
import FlyWheel from '../components/FlyWheel.vue';
import Brands from '../components/Brands.vue';
import Creators from '../components/Creators.vue';
import GetInTouch from '../components/GetInTouch.vue';
import CaseStudies from "../components/CaseStudies.vue";
import MeetTobias from "../components/MeetTobias.vue";
import { onMounted } from 'vue';

onMounted(() => {
  // Force scroll to top using multiple methods to ensure it works
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  window.scrollTo(0, 0);
});

// let isScrolling = false;
// const step = 100;
//
// const onWheel = (e: WheelEvent) => {
//   e.preventDefault(); // Stop default scrolling
//   if (isScrolling) return;
//
//   isScrolling = true;
//
//   const direction = e.deltaY > 0 ? 1 : -1;
//   const scrollAmount = direction * step;
//
//   window.scrollBy({
//     top: scrollAmount,
//     behavior: 'smooth',
//   });
//
//   // Small delay to throttle scrolling
//   setTimeout(() => {
//     isScrolling = false;
//   }, 50); // You can tweak this
// };
//
// window.addEventListener('wheel', onWheel, { passive: false });

</script>

<style scoped>

</style>
